import script from "./lessonChart.vue?vue&type=script&setup=true&lang=js"
export * from "./lessonChart.vue?vue&type=script&setup=true&lang=js"

import "./lessonChart.vue?vue&type=style&index=0&id=38c13fbb&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c13fbb"]])

export default __exports__